import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { currencyFormatter, percentageFormatter } from '../../../common/utils/helpers';
import Table from 'antd/lib/table';
import { ResponsiveTable } from '../../../common/components/data-display';


const Column = Table.Column;

@translate()
export default class DashboardTableSection extends Component {
    static propTypes = {
        title: PropTypes.string,
        units: PropTypes.string,
        cols: PropTypes.string
    };


    render() {
        const {
            title,
            units,
            cols
        } = this.props;




        return (
            <table className="section-header-table">
                <tbody>
                    <tr>
                        <th className={`section-title-col-${cols}`}><h3>{title}</h3></th>
                        <td className={`section-units-col-${cols}`}>{units}</td>
                    </tr>
                </tbody>
            </table>
        )
    }
}


// WEBPACK FOOTER //
// ./src/features/admin-dashboard/components/DashboardSectionHeader.js